namespace Portico.Directives {

	import Inject = Portico.Decorators.Inject;
	import pms = Portico.Models.Setup;
	import ps = Portico.Services;

	export interface ITcContentController {
		html: string;

		compile: () => void;
	}

	@Inject('$compile', '$element', '$scope')
	export class TcContentController implements ITcContentController {
		html: string;

		constructor(
			public $compile: angular.ICompileService,
			public $element: angular.IAugmentedJQuery,
			public $scope: angular.IScope
		) { }

		compile() {
			this.$element.html(this.html.replace(/&quot;/g, '\"'));
			this.$compile(this.$element.contents() as any)(this.$scope);
		}
	}

	angular.module('app').directive('tcContent', [() => {
		return {
			bindToController: {
				html: '@',
			},
			controller: <any>TcContentController,
			controllerAs: '$content',
			link: ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attr: angular.IAttributes, $ctrl: any[]) => {
				const tcContent: ITcContentController = $ctrl[0];
				tcContent.compile();
			},
			replace: true,
			require: ['tcContent'],
			restrict: 'E',
			scope: true
		};
	}]);
}
